import React, { useCallback, useRef, useState } from "react";
import Select from "react-select";
import DatePicker from "components/Common/DatePicker/datepicker";

const Search_By_Date = [
  { label: "Registration Date", value: "REGISTRATION_DATE" },
  { label: "Collection Date", value: "COLLECTION_DATE" },
  { label: "Receiving Date", value: "RECEIVING_DATE" },
  { label: "Approval Date", value: "APPROVAL_DATE" },
];

const today = new Date().toISOString().split("T")[0];

const getDefaultFilters = () => ({
  registration_no: "",
  appointment_id: "",
  patient_name: "",
  search_by_date: "REGISTRATION_DATE",
  date_from: today,
  date_to: today,
  barcode_no: "",
  refer_by: "",
  lab_department_id: "",
  investigation_id: "",
  package_id: "",
  franchise_id: "",
  urgent: false,
  delayed_tat: false,
});

const cleanFilters = (filtersObj) => {
  const ALWAYS_INCLUDE = ["date_from", "date_to", "search_by_date"];
  const cleaned = {};

  Object.entries(filtersObj).forEach(([key, value]) => {
    if (ALWAYS_INCLUDE.includes(key)) {
      cleaned[key] = value;
      return;
    }
    if (typeof value === "boolean") {
      if (value === true) cleaned[key] = value;
      return;
    }
    if (value === "" || value === null || value === undefined) return;

    cleaned[key] = value;
  });

  return cleaned;
};

const Filter = ({
  filters,
  updateFilter,
  updateMultipleFilters,
  options,
  investigation_list,
  package_list,
  franchise_list,
  lab_department_list,
}) => {
  const selectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  const [localFilters, setLocalFilters] = useState(() => ({
    ...getDefaultFilters(),
    ...filters,
  }));

  const isSearching = useRef(false);

  const handleLocalChange = useCallback((name, value) => {
    setLocalFilters((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleSearch = useCallback(() => {
    if (isSearching.current) return;
    isSearching.current = true;

    const cleaned = cleanFilters(localFilters);
    updateMultipleFilters(cleaned);

    setTimeout(() => {
      isSearching.current = false;
    }, 500);
  }, [localFilters, updateMultipleFilters]);

  const handleReset = useCallback(() => {
    const defaultFilters = getDefaultFilters();
    setLocalFilters(defaultFilters);
    updateMultipleFilters({
      date_from: defaultFilters.date_from,
      date_to: defaultFilters.date_to,
    });
  }, [updateMultipleFilters]);

  return (
    <div className="boxBody">
      <div className="heading-form">Search Options</div>

      <div className="row">
        <div className="col-md-2 mb-2">
          <label className="mb-2">Registration No.</label>
          <input
            name="registration_no"
            type="text"
            className="form-control"
            value={localFilters.registration_no}
            onChange={(e) =>
              handleLocalChange("registration_no", e.target.value)
            }
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
        </div>

        <div className="col-md-2 mb-2">
          <label className="mb-2">Appointment Id</label>
          <input
            name="appointment_id"
            type="text"
            className="form-control"
            value={localFilters.appointment_id}
            onChange={(e) =>
              handleLocalChange("appointment_id", e.target.value)
            }
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
        </div>

        <div className="col-md-2 mb-2">
          <label
            className="mb-2"
            style={{ color: "rgb(13, 110, 253)", fontWeight: "600" }}
          >
            Patient Name
          </label>
          <input
            name="patient_name"
            type="text"
            className="form-control"
            value={localFilters.patient_name}
            onChange={(e) => handleLocalChange("patient_name", e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
        </div>

        <div className="col-md-2 mb-2">
          <label className="mb-2">Search By Date</label>
          <Select
            options={Search_By_Date}
            name="search_by_date"
            isClearable
            placeholder="Search By Date"
            menuPortalTarget={document.body}
            styles={selectStyles}
            value={
              Search_By_Date.find(
                (item) => item.value === localFilters.search_by_date,
              ) || null
            }
            onChange={(val) =>
              handleLocalChange("search_by_date", val?.value || "")
            }
          />
        </div>

        <div className="col-md-2 mb-2">
          <label className="mb-2">From Date</label>
          <DatePicker
            name="date_from"
            value={localFilters.date_from}
            onChange={(date) => handleLocalChange("date_from", date)}
          />
        </div>

        <div className="col-md-2 mb-2">
          <label className="mb-2">To Date</label>
          <DatePicker
            name="date_to"
            value={localFilters.date_to}
            onChange={(date) => handleLocalChange("date_to", date)}
          />
        </div>

        <div className="col-md-2 mb-2">
          <label className="mb-2">Barcode Number</label>
          <input
            name="barcode_no"
            type="text"
            className="form-control"
            value={localFilters.barcode_no}
            onChange={(e) => handleLocalChange("barcode_no", e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
        </div>

        <div className="col-md-2 mb-2">
          <label className="mb-2">Refer By</label>
          <input
            name="refer_by"
            type="text"
            className="form-control"
            placeholder="Enter Refer By"
            value={localFilters.refer_by}
            onChange={(e) => handleLocalChange("refer_by", e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
        </div>

        <div className="col-md-2 mb-2">
          <label className="mb-2">Department</label>
          <Select
            options={lab_department_list?.data?.map((item) => ({
              value: item.id,
              label: item.department,
            }))}
            value={(() => {
              const item = lab_department_list?.data?.find(
                (i) => i.id == localFilters.lab_department_id,
              );
              return item
                ? { value: item.id, label: item.department || "" }
                : null;
            })()}
            name="lab_department_id"
            isClearable
            placeholder="Select Department"
            menuPortalTarget={document.body}
            styles={selectStyles}
            onChange={(val) =>
              handleLocalChange("lab_department_id", val?.value || "")
            }
          />
        </div>

        <div className="col-md-2 mb-2">
          <label className="mb-2">Investigation</label>
          <Select
            options={investigation_list?.data?.map((item) => ({
              value: item.id,
              label: item.investigation_name,
            }))}
            value={(() => {
              const item = investigation_list?.data?.find(
                (i) => i.id == localFilters.investigation_id,
              );
              return item
                ? { value: item.id, label: item.investigation_name || "" }
                : null;
            })()}
            name="investigation_id"
            isClearable
            placeholder="Select Investigation"
            menuPortalTarget={document.body}
            styles={selectStyles}
            onChange={(val) =>
              handleLocalChange("investigation_id", val?.value || "")
            }
          />
        </div>

        <div className="col-md-2 mb-2">
          <label className="mb-2">Package</label>
          <Select
            options={package_list?.data?.map((item) => ({
              value: item.id,
              label: item.package_name,
            }))}
            value={(() => {
              const item = package_list?.data?.find(
                (i) => i.id == localFilters.package_id,
              );
              return item
                ? { value: item.id, label: item.package_name || "" }
                : null;
            })()}
            name="package_id"
            isClearable
            placeholder="Select Package"
            menuPortalTarget={document.body}
            styles={selectStyles}
            onChange={(val) =>
              handleLocalChange("package_id", val?.value || "")
            }
          />
        </div>

        <div className="col-md-2 mb-2">
          <label className="mb-2">Panel</label>
          <Select
            key={
              franchise_list?.data ? "franchise-loaded" : "franchise-loading"
            }
            options={franchise_list?.data?.map((item) => ({
              value: item.id,
              label: `${item.company_name}, ${item.franchise_code}`,
            }))}
            value={(() => {
              const item = franchise_list?.data?.find(
                (i) => String(i.id) === String(localFilters.franchise_id),
              );
              return item
                ? {
                    value: item.id,
                    label: `${item.company_name}, ${item.franchise_code}`,
                  }
                : null;
            })()}
            name="franchise_id"
            isClearable
            placeholder="Select Panel"
            menuPortalTarget={document.body}
            styles={selectStyles}
            onChange={(val) =>
              handleLocalChange("franchise_id", val?.value || "")
            }
          />
        </div>

        <div className="col-md-2 mb-3">
          <div className="form-check mt-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="searchUrgent"
              checked={!!localFilters.urgent}
              onChange={(e) => handleLocalChange("urgent", e.target.checked)}
            />
            <label className="form-check-label" htmlFor="searchUrgent">
              Search Urgent Investigation
            </label>
          </div>
        </div>

        <div className="col-md-2 mb-3">
          <div className="form-check mt-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="delayedTat"
              checked={!!localFilters.delayed_tat}
              onChange={(e) =>
                handleLocalChange("delayed_tat", e.target.checked)
              }
            />
            <label className="form-check-label" htmlFor="delayedTat">
              Delayed TAT
            </label>
          </div>
        </div>

        <div className="col-md-2 mb-3 d-flex align-items-end gap-2">
          <button className="btn btn-primary" onClick={handleSearch}>
            Search
          </button>
          <button className="btn btn-secondary" onClick={handleReset}>
            Reset
          </button>
        </div>
      </div>
    </div>
  );
};

export default Filter;
